<template>
    <div class="bgTransparent w100 couplets-box">
        <div class="left"><img src="../assets/images/ej/dl-left4.gif" alt="" style="width: 95px; height: 683px;"></div><!--95px-->
        <div class="right"><img src="../assets/images/ej/dl-right4.gif" alt="" style="width: 95px; height: 683px;"></div><!--95px-->
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'CoupletsControl',
    data () {
        return {
            left: ''
        }
    },
    mounted () {
        // 初始化内容
        this.init();
        $(window).resize(() => {
            this.init();
        })
        
    },
    methods: {
        //页面操作
        init () {
            
        }
    },
}
</script>

<style scoped>
	.left {
		position: fixed;
		top: 110px;
		left: calc(50vw - 600px - 105px);
	}
	.right {
		position: fixed;
		top: 110px;
		right: calc(50vw - 600px - 105px);
	}
</style>